import type { ComponentType, SVGProps } from 'react';
import type { EventType } from '@/types/db';
import {
  DoctorVisitIcon,
  DocumentIcon,
  LabReportIcon,
  PrescriptionIcon,
  ScanIcon,
  VaccineIcon,
  VitalsIcon,
} from '@/components/icons/event-type-icons';

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

export interface EventTypeMeta {
  label: string;
  Icon: IconComponent;
  iconBg: string;
  iconText: string;
  dot: string;
  pillBg: string;
  pillText: string;
  rail: string;
}

export const EVENT_TYPE_META: Record<EventType, EventTypeMeta> = {
  prescription: {
    label: 'Prescription',
    Icon: PrescriptionIcon,
    iconBg: 'bg-evt-rx-soft',
    iconText: 'text-evt-rx-ink',
    dot: 'bg-evt-rx',
    pillBg: 'bg-evt-rx-soft',
    pillText: 'text-evt-rx-ink',
    rail: 'bg-evt-rx',
  },
  vaccine: {
    label: 'Vaccine',
    Icon: VaccineIcon,
    iconBg: 'bg-evt-vax-soft',
    iconText: 'text-evt-vax-ink',
    dot: 'bg-evt-vax',
    pillBg: 'bg-evt-vax-soft',
    pillText: 'text-evt-vax-ink',
    rail: 'bg-evt-vax',
  },
  doctor_visit: {
    label: 'Doctor visit',
    Icon: DoctorVisitIcon,
    iconBg: 'bg-evt-visit-soft',
    iconText: 'text-evt-visit-ink',
    dot: 'bg-evt-visit',
    pillBg: 'bg-evt-visit-soft',
    pillText: 'text-evt-visit-ink',
    rail: 'bg-evt-visit',
  },
  lab_report: {
    label: 'Lab report',
    Icon: LabReportIcon,
    iconBg: 'bg-evt-lab-soft',
    iconText: 'text-evt-lab-ink',
    dot: 'bg-evt-lab',
    pillBg: 'bg-evt-lab-soft',
    pillText: 'text-evt-lab-ink',
    rail: 'bg-evt-lab',
  },
  scan: {
    label: 'Scan',
    Icon: ScanIcon,
    iconBg: 'bg-evt-scan-soft',
    iconText: 'text-evt-scan-ink',
    dot: 'bg-evt-scan',
    pillBg: 'bg-evt-scan-soft',
    pillText: 'text-evt-scan-ink',
    rail: 'bg-evt-scan',
  },
  vitals: {
    label: 'Vitals',
    Icon: VitalsIcon,
    iconBg: 'bg-evt-vitals/20',
    iconText: 'text-evt-vitals-ink',
    dot: 'bg-evt-vitals',
    pillBg: 'bg-evt-vitals-soft',
    pillText: 'text-evt-vitals-ink',
    rail: 'bg-evt-vitals',
  },
  other: {
    label: 'Other',
    Icon: DocumentIcon,
    iconBg: 'bg-evt-other-soft',
    iconText: 'text-evt-other-ink',
    dot: 'bg-evt-other',
    pillBg: 'bg-evt-other-soft',
    pillText: 'text-evt-other-ink',
    rail: 'bg-evt-other',
  },
};

export function getEventTypeMeta(type: EventType | string): EventTypeMeta {
  return EVENT_TYPE_META[type as EventType] ?? EVENT_TYPE_META.other;
}
